export enum GraphBarType {
  Paid = 'values.paid',
  Unpaid = 'values.unpaid',
}
